import http from '../services/http'
import { errorText } from '../services/api'

// 两个政策实训入口共用文件操作；每次都向服务器重新校验下载权限。
export default {
  data () { return { reportBusy: '', reportDocumentSequence: 0, documentError: '' } },
  beforeDestroy () { this.reportDocumentSequence++; this.removePolicyPrintArea() },
  methods: {
    async usePolicyReportDocument (kind) {
      if (!['print', 'pdf', 'html'].includes(kind) || this.busy || this.reportBusy || !this.policyReportCanDownload) return
      const sequence = ++this.reportDocumentSequence, route = this.$route.fullPath
      const current = () => sequence === this.reportDocumentSequence && route === this.$route.fullPath
      this.reportBusy = kind; this.documentError = ''
      try {
        const result = await http.get(kind === 'pdf' ? this.policyReportPdfUrl : this.policyReportHtmlUrl, { responseType: kind === 'pdf' ? 'blob' : 'text', timeout: 60000 })
        if (!current()) return
        if (kind === 'pdf' && await result.data.slice(0, 5).text() !== '%PDF-') throw new Error('报告接口未返回有效 PDF，请刷新后重试')
        if (!current()) return
        if (kind === 'print') {
          this.removePolicyPrintArea()
          const area = document.createElement('div')
          area.id = 'network-lab-print-area'; area.className = 'city-lab lab-print-root'
          area.innerHTML = new DOMParser().parseFromString(result.data, 'text/html').body.innerHTML
          document.body.appendChild(area)
          window.addEventListener('afterprint', this.removePolicyPrintArea, { once: true })
          window.print()
        } else {
          const blob = kind === 'pdf' ? result.data : new Blob([result.data], { type: 'text/html;charset=utf-8' })
          const url = URL.createObjectURL(blob), link = document.createElement('a')
          const name = (kind === 'html' ? '公共政策智能分析实训报告' : this.policyReportFileName).replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_').slice(0, 120)
          link.href = url; link.download = name + (kind === 'pdf' ? '.pdf' : '.html')
          document.body.appendChild(link); link.click(); link.remove()
          window.setTimeout(() => URL.revokeObjectURL(url), 1000)
        }
      } catch (error) {
        if (!current()) return
        this.removePolicyPrintArea()
        let data = error && error.response && error.response.data
        if (data instanceof Blob) data = await data.text()
        if (!current()) return
        if (typeof data === 'string') { try { data = JSON.parse(data) } catch (_) { data = null } }
        this.documentError = (data && data.message) || errorText(error)
        this.$message.error(this.documentError)
        if (error.response?.status === 403) {
          if (this.reportData) this.reportData.canDownload = false
          else this.canDownload = false
        }
      } finally { if (sequence === this.reportDocumentSequence) this.reportBusy = '' }
    },
    removePolicyPrintArea () {
      window.removeEventListener('afterprint', this.removePolicyPrintArea)
      const area = document.getElementById('network-lab-print-area'); if (area) area.remove()
    }
  }
}
